import * as libFund from './fund';
import { exactValidator, genericValidateName, SEPARATOR, uuidValidator } from './genericName';
export const prefix = 'quantificationSnapshots';
export const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ fundID, quantificationSnapshotID }) => {
    return libFund.IDToName({ fundID }) + SEPARATOR + prefixWithSeparator + quantificationSnapshotID;
};
export const validateName = genericValidateName([
    exactValidator(libFund.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split(SEPARATOR);
    return {
        fundID: parts[1],
        quantificationSnapshotID: parts[3],
    };
};
